<div class="refund-policy-container">
    <h1 class="title">Refund Policy</h1>

    <section class="policy-introduction">
        <h2>Sharani Ponguru – The Mindset Movement</h2>
        <p>Sharani Ponguru is committed to providing each customer with exceptional service.</p>
        <p>We want you to feel completely comfortable transacting with us. Due to the nature of our offerings and the instant accessibility of digital bonuses, we offer a generous 7-day full refund policy, starting from the date of purchase. Refunds will be processed and credited back to your original payment method within 7 business days.</p>
        <p>If you are not fully satisfied with your purchase, please reach out to us at thesharaniponguru@gmail.com within 7 days of your purchase, and we will issue you a full refund — no questions asked.</p>
    </section>
</div>